/**
 * Shared ruby / Japanese markup helpers for Event.text.
 * Internal form: <ruby data-align="center|around">BASE<rt>RUBY</rt></ruby>
 * Also supports: <span class="text-combine">…</span>
 *                <span class="bouten-fco|fdo|fso|oco|odo|oso">…</span>
 */

const RUBY_RE = /<ruby([^>]*)>([\s\S]*?)<\/ruby>/gi;
const RT_RE = /<rt\b[^>]*>([\s\S]*?)<\/rt>/i;
function hasRuby(text) {
  return /<ruby\b/i.test(text || "");
}
function isVerticalWritingMode(writingMode) {
  return writingMode === "tbrl";
}

/**
 * Remove bouten / text-combine wrappers, keeping inner text.
 */
function stripJapaneseExtras(text) {
  if (!text) {
    return "";
  }
  return text.replace(/<span\b[^>]*class=["']text-combine["'][^>]*>([\s\S]*?)<\/span>/gi, "$1").replace(/<(?:em|span)\b[^>]*class=["']bouten-[a-z]+["'][^>]*>([\s\S]*?)<\/(?:em|span)>/gi, "$1");
}

/**
 * Convert HTML ruby markup to parenthetical form: BASE(RUBY)
 * Used by SubRip and as a WebVTT fallback.
 */
function rubyToParenthetical(text) {
  if (!text) {
    return "";
  }
  let out = stripJapaneseExtras(text);
  out = out.replace(RUBY_RE, (match, attrs, inner) => {
    const rtMatch = inner.match(RT_RE);
    const rubyText = rtMatch ? rtMatch[1] : "";
    const base = inner.replace(RT_RE, "").replace(/<\/?[^>]+>/g, "");
    if (rubyText) {
      return `${base}(${rubyText})`;
    }
    return base;
  });
  return out;
}

/**
 * Strip ruby annotations, keeping only base text. Also unwraps bouten/combine.
 */
function rubyToBaseOnly(text) {
  if (!text) {
    return "";
  }
  let out = stripJapaneseExtras(text);
  out = out.replace(RUBY_RE, (match, attrs, inner) => {
    return inner.replace(RT_RE, "").replace(/<\/?[^>]+>/g, "");
  });
  return out;
}

/**
 * Prepare Event.text for WebVTT with native HTML ruby.
 * Strips data-align (not valid in VTT) but keeps <ruby>/<rt>.
 */
function rubyToWebVtt(text) {
  if (!text) {
    return "";
  }
  return stripJapaneseExtras(text).replace(/<ruby([^>]*)>/gi, "<ruby>").replace(/<\/?span\b[^>]*>/gi, "");
}

/**
 * Convert parenthetical BASE(RUBY) tokens into HTML ruby markup.
 * Matches the convention used by imscTextCaptionsJa / Canvass SST.
 */
function parentheticalToRuby(text, align = "center") {
  if (!text) {
    return "";
  }
  return text.replace(/([^\s()]+)\(([^)]+)\)/g, (match, base, ruby) => {
    return `<ruby data-align="${align}">${base}<rt>${ruby}</rt></ruby>`;
  });
}

/**
 * Escape XML special characters in text nodes.
 */
function escapeXml(text) {
  return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
export default {
  hasRuby,
  isVerticalWritingMode,
  stripJapaneseExtras,
  rubyToParenthetical,
  rubyToBaseOnly,
  rubyToWebVtt,
  parentheticalToRuby,
  escapeXml,
  RUBY_RE,
  RT_RE
};